<template>
  <div class="auth">
    <the-login-form
      class="login-form"
      appName="WebData"
      :status="statusSignIn"
      :defaultUserName="userName"
      @onSignIn="onSignIn"
    ></the-login-form>
  </div>
</template>

<script>
import TheLoginForm from "../components/library.blocks/TheLoginForm.vue";

import { mapState } from "vuex";

import { AUTHORIZATION } from "@/store/type";
import { HOME } from "@/router/type";
import { validatePrivilege } from "@/router/utils";

export default {
  name: "Auth",
  components: {
    TheLoginForm
  },
  data() {
    return {
      statusSignIn: 0
    };
  },
  computed: {
    ...mapState({
      userName: state => state.users.login,
      auth: state => state.users.auth
    })
  },
  methods: {
    onSignIn(user) {
      this.$store
        .dispatch(AUTHORIZATION, user)
        .then(okStatus => {
          if (validatePrivilege(this.auth)) {
            this.setStatus(okStatus);
            this.redirect();
          } else {
            this.setStatus(401);
          }
        })
        .catch(errStatus => this.setStatus(errStatus));
    },
    setStatus(status) {
      this.statusSignIn = status;
    },
    redirect() {
      if (this.$route.query.redirect) {
        this.$router.push(this.$route.query.redirect);
      } else {
        this.$router.push(HOME);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.auth {
  position: relative;

  .login-form {
    position: fixed;
    top: 35%;
    left: 40%;
  }
}
</style>
